<template>
  <span style="display: none"></span>
</template>
<script>
export default {
  emits: ['changeValue'],
  components: {
    //
  },
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    event() {
      return this.config?.event ?? null
    },
    more() {
      return this.config?.more || {}
    },
    condition() {
      return this.config?.condition || {}
    },
    packages() {
      return this.more?.receive_packages || {}
    },
    groups() {
      return this.more?.groups || {}
    }
  },
  methods: {
    changeValue(field, value) {
      this.$emit('changeValue', {
        field,
        value
      })
    }
  },
  props: {
    config: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
